module.exports = __webpack_public_path__ + "img/raselevaly.4f06cb12.jpg";